import { CheckboxFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/CheckboxFilter/CheckboxFilter";
import { CheckboxFilterResult } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/CheckboxFilter/CheckboxFilterResult";
import { CheckboxFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/CheckboxFilterModel";
import type { IFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import type { IAppsCommonFiltersDto } from "app/pages/sales-intelligence/store/find-apps/types";

const createBusinessModelFilter = (businessModels: readonly string[]): IFilterInstance<IAppsCommonFiltersDto> => {
    return {
        key: "appBusinessModels",
        trackingName: "App Business Model",
        title: { key: "si.find_apps.filters.business-models.title" },
        tooltipText: { key: "si.find_apps.filters.business-models.tooltip" },
        filter: new CheckboxFilterModel(businessModels, "si.find_apps.filters.business-models.option"),
        filterView: CheckboxFilter,
        filterResultView: CheckboxFilterResult,
    };
};

export default createBusinessModelFilter;
